// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"cc5fa4b2","893":"8ed95fbc"}[chunkId] + ".chunk.js";
};